import { useCallback } from 'react';
import { getRequestParams, formatDate, formatTime } from '../../../../helpers/globalfunctions.js';
import { DateFormat } from '../../../../helpers/fixcodes.js';
import { terminalTypeData } from '../../shared/constants';
import Swal from 'sweetalert2';
import moment from 'moment/min/moment-with-locales';

const google = window.google;

// ─── pure recurring helpers ──────────────────────────────────────────────────

function diffDays(d1, d2) {
  const ndays = (d2.valueOf() - d1.valueOf()) / 1000 / 86400;
  return Math.round(ndays - 0.5);
}

function getDailyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuDay = state.selectedDays.map((d) => d.toLocaleDateString());
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuDay.includes(stpuDate.toLocaleDateString())) {
      finalArrayList.push(
        ((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) +
        '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) +
        '/' + stpuDate.getFullYear()
      );
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

function getWeeklyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuDay = [];
  if (state.isWeekMon) chkPuDay.push(1);
  if (state.isWeekTue) chkPuDay.push(2);
  if (state.isWeekWed) chkPuDay.push(3);
  if (state.isWeekThu) chkPuDay.push(4);
  if (state.isWeekFri) chkPuDay.push(5);
  if (state.isWeekSat) chkPuDay.push(6);
  if (state.isWeekSun) chkPuDay.push(0);
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuDay.includes(stpuDate.getDay())) {
      finalArrayList.push(
        ((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) +
        '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) +
        '/' + stpuDate.getFullYear()
      );
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

function getMonthlyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuMonths = [];
  if (state.isMonthMon) chkPuMonths.push(1);
  if (state.isMonthTue) chkPuMonths.push(2);
  if (state.isMonthWed) chkPuMonths.push(3);
  if (state.isMonthThu) chkPuMonths.push(4);
  if (state.isMonthFri) chkPuMonths.push(5);
  if (state.isMonthSat) chkPuMonths.push(6);
  if (state.isMonthSun) chkPuMonths.push(0);
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuMonths.includes(stpuDate.getDay())) {
      finalArrayList.push(
        ((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) +
        '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) +
        '/' + stpuDate.getFullYear()
      );
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

function getRecurringPuDateArrayList(state) {
  if (state.recurringTypeId == 1) return getDailyRecurringDays(state);
  if (state.recurringTypeId == 2) return getWeeklyRecurringDays(state);
  if (state.recurringTypeId == 3) return getMonthlyRecurringDays(state);
  return [];
}

// ─── trip changes log ────────────────────────────────────────────────────────

function getTripChangesDetails(state, props, rideTypeIdRef) {
  if (props.tripDetails == null) return '';

  const tripDetails = props.tripDetails;
  let changes = '';
  const rideTypeIdOld = parseInt(tripDetails.rideTypeId);

  let puZone = null;
  let doZone = null;
  if (rideTypeIdOld === 1) {
    puZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.id === tripDetails.doAreaId) || null;
  } else if (rideTypeIdOld === 2) {
    puZone = state.dropdownZone.find((opt) => opt.id === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
  } else if (rideTypeIdOld === 3) {
    puZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
  } else {
    puZone = state.dropdownZone.find((opt) => opt.id === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.id === tripDetails.doAreaId) || null;
  }

  const airlineIdOld = parseInt((rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId);
  const flightNoOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo;
  const terminalTypeOld = parseInt((rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId);
  const terminalOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal;
  const flightDateOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? new Date(tripDetails.puFlightDateTime) : new Date(tripDetails.doFlightDateTime);

  if (state.paxFirstName !== tripDetails.firstName) changes += 'Pax first name changed from ' + tripDetails.firstName + ' to ' + state.paxFirstName + '. ';
  if (state.paxLastName !== tripDetails.lastName) changes += 'Pax last name changed from ' + tripDetails.lastName + ' to ' + state.paxLastName + '. ';
  if (state.countryCodePhone !== tripDetails.countryCode) changes += 'Country code changed from ' + tripDetails.countryCode + ' to ' + state.countryCodePhone + '. ';
  if (state.phoneNumber !== tripDetails.phoneNo) changes += 'Phone no changed from ' + tripDetails.phoneNo + ' to ' + state.phoneNumber + '. ';
  if (state.countryCode !== tripDetails.cellCountryCode) changes += 'Cell country code changed from ' + tripDetails.cellCountryCode + ' to ' + state.countryCode + '. ';
  if (state.mobileNumber !== tripDetails.mobileNo) changes += 'Mobile number changed from ' + tripDetails.mobileNo + ' to ' + state.mobileNumber + '. ';

  if (parseInt(state.airlineId) !== airlineIdOld) {
    const newAirline = state.dropdownAirline.find((opt) => opt.airLineId === parseInt(state.airlineId));
    const oldAirline = state.dropdownAirline.find((opt) => opt.airLineId === airlineIdOld);
    if (oldAirline) {
      changes += 'Airline changed from ' + oldAirline.airLineName + ' to ' + (newAirline ? newAirline.airLineName : '') + '. ';
    } else {
      changes += 'Airline changed to ' + (newAirline ? newAirline.airLineName : '') + '. ';
    }
  }
  if (state.flightNumber !== flightNoOld) changes += 'Flight number changed from ' + flightNoOld + ' to ' + state.flightNumber + '. ';

  if (parseInt(state.terminalType) !== terminalTypeOld) {
    const newT = terminalTypeData.find((opt) => opt.id === parseInt(state.terminalType));
    const oldT = terminalTypeData.find((opt) => opt.id === terminalTypeOld);
    changes += 'Terminal type changed from ' + (oldT ? oldT.name : '') + ' to ' + (newT ? newT.name : '') + '. ';
  }
  if (state.terminal !== terminalOld) changes += 'Terminal changed from ' + terminalOld + ' to ' + state.terminal + '. ';
  if (parseInt(state.pilotCount) !== parseInt(tripDetails.iPilot)) changes += 'Pilot count changed from ' + tripDetails.iPilot + ' to ' + state.pilotCount + '. ';
  if (parseInt(state.crewCount) !== parseInt(tripDetails.iCrew)) changes += 'Crew count changed from ' + tripDetails.iCrew + ' to ' + state.crewCount + '. ';
  if (parseInt(state.flightAttandCount) !== parseInt(tripDetails.iFlightAttendent)) changes += 'F/A count changed from ' + tripDetails.iFlightAttendent + ' to ' + state.flightAttandCount + '. ';

  const flightTimeNew = state.puDateTime.toLocaleDateString() + ' ' + new Date(state.flightTime).toLocaleTimeString();
  const flightTimeOld = flightDateOld.toLocaleDateString() + ' ' + flightDateOld.toLocaleTimeString();
  if (flightTimeNew !== flightTimeOld) changes += 'Flight date changed from ' + flightTimeOld + ' to ' + flightTimeNew + '. ';

  if (state.email !== tripDetails.emailId) changes += 'Email changed from ' + tripDetails.emailId + ' to ' + state.email + '. ';
  if (state.poNumber !== tripDetails.crewPo) changes += 'PO changed from ' + tripDetails.crewPo + ' to ' + state.poNumber + '. ';

  if (state.pickupLocation !== tripDetails.puLocationName) changes += 'Pick-up location changed from ' + tripDetails.puLocationName + ' to ' + state.pickupLocation + '. ';
  if (parseInt(state.pickupZoneId) !== parseInt(puZone != null ? puZone.id : 0)) {
    const puZoneNew = state.dropdownZone.find((opt) => opt.id === parseInt(state.pickupZoneId));
    changes += 'Pick-up zone changed from ' + (puZone ? puZone.name : '') + ' to ' + (puZoneNew ? puZoneNew.name : '') + '. ';
  }
  if (state.pickupAddress !== tripDetails.puAddress) changes += 'Pick-up address changed from ' + tripDetails.puAddress + ' to ' + state.pickupAddress + '. ';

  if (state.dropoffLocation !== tripDetails.doLocationName) changes += 'Drop off location changed from ' + tripDetails.doLocationName + ' to ' + state.dropoffLocation + '. ';
  if (parseInt(state.dropoffZoneId) !== parseInt(doZone != null ? doZone.id : 0)) {
    const doZoneNew = state.dropdownZone.find((opt) => opt.id === parseInt(state.dropoffZoneId));
    changes += 'Drop off zone changed from ' + (doZone ? doZone.name : '') + ' to ' + (doZoneNew ? doZoneNew.name : '') + '. ';
  }
  if (state.dropoffAddress !== tripDetails.doAddress) changes += 'Drop off address changed from ' + tripDetails.doAddress + ' to ' + state.dropoffAddress + '. ';

  if (parseInt(state.serviceSourceId) !== parseInt(tripDetails.serviceSourceId)) {
    const newSource = parseInt(state.serviceSourceId) === 1 ? 'In House' : (parseInt(state.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    const oldSource = parseInt(tripDetails.serviceSourceId) === 1 ? 'In House' : (parseInt(tripDetails.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    changes += 'Service source changed from ' + oldSource + ' to ' + newSource + '. ';
  }
  if (parseInt(state.otherAffiliateId) !== parseInt(tripDetails.serviceSourceAffiliateId)) {
    if (parseInt(state.otherAffiliateId) > 0 && parseInt(tripDetails.serviceSourceAffiliateId) === 0) {
      const newSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(state.otherAffiliateId));
      changes += 'Source affiliate added ' + (newSource ? newSource.name : '') + '. ';
    } else if (parseInt(state.otherAffiliateId) === 0 && parseInt(tripDetails.serviceSourceAffiliateId) > 0) {
      const oldSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(tripDetails.serviceSourceAffiliateId));
      changes += 'Source affiliate removed ' + (oldSource ? oldSource.name : '') + '. ';
    } else {
      const newSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(state.otherAffiliateId));
      const oldSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(tripDetails.serviceSourceAffiliateId));
      changes += 'Source affiliate changed from ' + (oldSource ? oldSource.name : '') + ' to ' + (newSource ? newSource.name : '') + '. ';
    }
  }

  if (state.isVipTrip !== (tripDetails.vip === 'Y')) changes += 'VIP changed from ' + (state.isVipTrip ? 'NO to YES' : 'YES to NO') + '. ';
  if (state.isMeetGreet !== tripDetails.isMgRequired) changes += 'MeetGreet changed from ' + (state.isMeetGreet ? 'NO to YES' : 'YES to NO') + '. ';

  const puDateNew = state.puDateTime.toLocaleDateString() + ' ' + state.puDateTime.toLocaleTimeString();
  const puDateOld = new Date(tripDetails.puDateTime).toLocaleDateString() + ' ' + new Date(tripDetails.puDateTime).toLocaleTimeString();
  if (puDateNew !== puDateOld) changes += 'Pick-up date changed from ' + puDateOld + ' to ' + puDateNew + '. ';

  if (parseInt(state.vehicleTypeId) !== parseInt(tripDetails.apiVehicleTypeId)) {
    const newVT = state.dropdownVehicleType.find((opt) => opt.rowIndex === parseInt(state.vehicleTypeId));
    const oldVT = state.dropdownVehicleType.find((opt) => opt.rowIndex === parseInt(tripDetails.apiVehicleTypeId));
    if (oldVT) changes += 'Vehicle type changed from ' + oldVT.apiVehicleTypeDescription + ' to ' + (newVT ? newVT.apiVehicleTypeDescription : '') + '. ';
    else if (newVT) changes += 'Vehicle type changed to ' + newVT.apiVehicleTypeDescription + '. ';
  }

  if (state.specialInstruction !== tripDetails.specialInstruction) changes += 'Spcl Inst. changed from ' + tripDetails.specialInstruction + ' to ' + state.specialInstruction + '. ';
  if (state.permanentRemark !== tripDetails.permanentRemark) changes += 'Permanent remark changed from ' + tripDetails.permanentRemark + ' to ' + state.permanentRemark + '. ';
  if (state.pickupNotes !== tripDetails.pickUpNotes) changes += 'Pick-up notes changed from ' + tripDetails.pickUpNotes + ' to ' + state.pickupNotes + '. ';
  if (state.billToNotes !== tripDetails.billToNotes) changes += 'Bill notes changed from ' + tripDetails.billToNotes + ' to ' + state.billToNotes + '. ';

  return changes === '' ? 'Ride updated without any changes.' : changes;
}

// ─── clearAllControls ────────────────────────────────────────────────────────

function clearAllControls(setState, customer) {
  const currentTime = sessionStorage.getItem('session_locationTime') === ''
    ? new Date()
    : new Date(sessionStorage.getItem('session_locationTime'));
  const currentHour = new Date(currentTime).getHours();
  const currentMinute = new Date(currentTime).getMinutes();

  setState({
    rideId: 0,
    paxFirstName: '',
    paxLastName: '',
    countryCodePhone: '1',
    phoneNumber: '',
    countryCode: '1',
    mobileNumber: '',
    airlineId: customer ? customer.airlineId : 0,
    flightNumber: '',
    terminalType: 1,
    terminal: '',
    pilotCount: 0,
    crewCount: 0,
    flightAttandCount: 0,
    flightTime: currentTime,
    flightHour: currentHour,
    flightMinute: currentMinute,
    flightHourReturn: currentHour,
    flightMinuteReturn: currentMinute,
    airlineIdReturn: customer ? customer.airlineId : 0,
    flightNumberReturn: '',
    terminalTypeReturn: 1,
    terminalReturn: '',
    flightTimeReturn: currentTime,
    pilotCountReturn: 0,
    crewCountReturn: 0,
    flightAttandCountReturn: 0,
    email: '',
    isSendEmail: false,
    poNumber: '',
    isPickupGoogleBooking: false,
    pickupLocation: '',
    pickupZoneId: 0,
    pickupAddress: '',
    pickupAddressType: '',
    pickupCity: '',
    pickupState: '',
    pickupZipCode: '',
    pickupLatitude: 0,
    pickupLongitude: 0,
    isDropoffGoogleBooking: false,
    dropoffLocation: '',
    dropoffZoneId: 0,
    dropoffAddress: '',
    dropoffAddressType: '',
    dropoffCity: '',
    dropoffState: '',
    dropoffZipCode: '',
    dropoffLatitude: 0,
    dropoffLongitude: 0,
    serviceSourceId: 1,
    otherAffiliateId: 0,
    isVipTrip: false,
    isMeetGreet: false,
    puDateTime: currentTime,
    puDateTimeReturn: currentTime,
    vehicleTypeId: 0,
    noOfTrip: 1,
    tripTypeId: '1',
    recurringTypeId: 2,
    recurringEndDate: '',
    selectedDays: [],
    isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
    isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
    specialInstruction: '',
    permanentRemark: '',
    pickupNotes: '',
    billToNotes: '',
    customerRateTax: null,
    loadPanelVisible: false,
    isCopy: false,
    isAttachment: false,
    errors: {
      paxFirstName: '', paxLastName: '', countryCode: '', mobileNumber: '', email: '',
      airlineId: '', flightNumber: '', terminalType: '', pilotCount: '', flightTime: '',
      airlineIdReturn: '', flightNumberReturn: '', terminalTypeReturn: '', pilotCountReturn: '', flightTimeReturn: '',
      pickupLocation: '', pickupZoneId: '', dropoffLocation: '', dropoffZoneId: '',
      otherAffiliateId: '', puDateTime: '', puDateTimeReturn: '', vehicleTypeId: '', noOfTrip: '',
      recurringEndDate: '', recurring: '',
    },
  });
}

// ─── hook ─────────────────────────────────────────────────────────────────────

export function useAirportApi(state, setState, rideTypeIdRef, isLoadingTimeRef, vehicleDriverRef, duplicationModalRef, props) {

  const getAirlines = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_airlines'));
      if (data === null) {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('air-line-api/' + 0, requestParams);
        const json = await response.json();
        setState({ dropdownAirline: json.airLine || [] });
      } else {
        setState({ dropdownAirline: data.airLine || [] });
      }
    } catch (e) { console.log(e); }
  }, [setState]);

  const getVehicleType = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_vehicletype'));
      if (data === null) {
        const requestParams = getRequestParams('POST', {});
        const response = await fetch('vehicletype-api/vehicletype', requestParams);
        const json = await response.json();
        setState({ dropdownVehicleType: json?.apiVehicleType || [] });
      } else {
        setState({ dropdownVehicleType: data?.data?.apiVehicleType || data?.apiVehicleType || [] });
      }
    } catch (e) { console.log(e); }
  }, [setState]);

  const getAffiliates = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('account-api/affliate-dropdown', requestParams);
      const json = await response.json();
      setState({ dropdownAffiliates: json.affiliatesDropdownList || [] });
    } catch (e) { console.log(e); }
  }, [setState]);

  const getZones = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_zones'));
      if (data === null) {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('serviceAreaZone-api/zone-dropdown/0/0', requestParams);
        const json = await response.json();
        setState({ dropdownZone: json.locationServiceAreaZoneList || [] });
      } else {
        setState({ dropdownZone: data.locationServiceAreaZoneList || [] });
      }
    } catch (e) { console.log(e); }
  }, [setState]);

  const getRideTypeId = useCallback((fromZId, toZId) => {
    rideTypeIdRef.current = 0;
    setState({ isMeetGreet: false });

    if (fromZId > 0 && toZId > 0) {
      const puZone = state.dropdownZone.find((opt) => opt.id === fromZId);
      const doZone = state.dropdownZone.find((opt) => opt.id === toZId);

      if (puZone && doZone) {
        if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
          rideTypeIdRef.current = 1;
        } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
          rideTypeIdRef.current = 2;
        } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
          rideTypeIdRef.current = 3;
        } else {
          rideTypeIdRef.current = 13;
        }
      }
    }
  }, [state.dropdownZone, rideTypeIdRef, setState]);

  const getCustomerRateTaxSetting = useCallback(async (fromZId, toZId, puDateTime, vTypeId, pCount, hNumber, bMeetGreet) => {
    try {
      if (fromZId > 0 && toZId > 0 && puDateTime !== '' && vTypeId > 0 && pCount > 0) {
        let fromAirId = 0, toAirId = 0, fromZoneId = 0, toZoneId = 0;

        const puZone = state.dropdownZone.find((opt) => opt.id === fromZId);
        const doZone = state.dropdownZone.find((opt) => opt.id === toZId);

        if (puZone && doZone) {
          if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
            fromAirId = puZone.airportId; toZoneId = doZone.id;
          } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
            fromZoneId = puZone.id; toAirId = doZone.airportId;
          } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
            fromAirId = puZone.airportId; toAirId = doZone.airportId;
          } else {
            fromZoneId = puZone.id; toZoneId = doZone.id;
          }
        }

        const newObject = {
          RideTypeId: rideTypeIdRef.current,
          FromAirportId: fromAirId,
          ToAirportId: toAirId,
          FromZoneId: fromZoneId,
          ToZoneId: toZoneId,
          PickUpDateTime: formatDate(puDateTime, 'MM/dd/yyyy') + ' ' + formatTime(puDateTime, 'hh:mm:ss'),
          ApiVehicleTypeId: vTypeId,
          NoOfHours: hNumber,
          NoOfPax: pCount,
          RateId: 0,
          IsMgRequired: bMeetGreet,
        };

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('customer-api/' + state.customer.id + '/rate-tax-setting', requestParams);
        const data = await response.json();
        setState({ customerRateTax: data });
        return data;
      }
      return null;
    } catch (e) { console.log(e); return null; }
  }, [state.dropdownZone, state.customer, rideTypeIdRef, setState]);

  const getBookingSuggestions = useCallback(async (value) => {
    const escapedValue = value.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (escapedValue === '') return [];

    const requestParams = getRequestParams('GET', '');
    const response = await fetch('address-search-api/' + state.customer.id + '/' + state.customer.customerTypeId + '/' + value, requestParams);
    const data = await response.json();
    setState({ bookingAddress: data === false ? [] : data.addressSearchList });
    const suggestions = data === false ? [] : data.addressSearchList;
    if (suggestions.length === 0) return [{ isNotFound: true }];
    return suggestions;
  }, [state.customer, setState]);

  const checkDuplicateReservation = useCallback(async (isButtonShow) => {
    let isResult = false;

    const newObject = {
      CustomerId: parseInt(state.customer.id),
      FromDate: moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateFormat) + ' 00:00',
      ToDate: moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateFormat) + ' 23:59',
    };

    try {
      if (isButtonShow === false) props.duplicateFunction(true);
      const requestParams = getRequestParams('POST', newObject);
      const response = await fetch('reservation-api/duplicate-list', requestParams);
      const data = await response.json();

      if (data.duplicateTrips.length > 0) {
        props.duplicateFunction(false);
        await Swal.fire({
          title: '<small>Duplicate trips</small>', text: 'Duplicate trip(s) found!',
          icon: 'success', width: '25%', dangerMode: false, allowOutsideClick: false,
        });
        duplicationModalRef.current.showModal(data.duplicateTrips, isButtonShow);
        isResult = true;
      } else if (isButtonShow === false) {
        props.duplicateFunction(false);
        await Swal.fire({
          title: '<small>Duplicate trips</small>', text: 'Duplicate trip(s) not found!',
          icon: 'success', width: '25%', dangerMode: false, allowOutsideClick: false,
        });
      }
      return isResult;
    } catch (e) { console.log(e); }
  }, [state, setState, props, duplicationModalRef]);

  const askDuplicateConfirm = useCallback(async () => {
    let isResult = false;
    await Swal.fire({
      title: '<small>Duplicate trips</small>',
      html: 'Duplicate trip(s) found.<br> Do you want to continue ..... ?',
      icon: 'question', showCancelButton: true,
      confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Continue', allowOutsideClick: false,
    }).then((result) => { if (result.isConfirmed) isResult = true; });
    return isResult;
  }, []);

  const askScheduleTimeConfirm = useCallback(async () => {
    debugger;
    let isResult = false;
    await Swal.fire({
      title: '<small>Are you sure</small>',
      html: 'Pick-up time should be minimum 10 minutes less than schedule time!<br> Do you want to still continue?',
      icon: 'question', showCancelButton: true,
      confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Continue', allowOutsideClick: false,
    }).then((result) => { if (result.isConfirmed) isResult = true; });
    return isResult;
  }, []);

  const askReturnTripConfirm = useCallback(async () => {
    let isResult = false;
    await Swal.fire({
      title: '<small>Are you sure</small>',
      html: 'You are going book a return trip!<br> Do you want to still continue?',
      icon: 'question', showCancelButton: true,
      confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Continue', allowOutsideClick: false,
    }).then((result) => { if (result.isConfirmed) isResult = true; });
    return isResult;
  }, []);

  const askBookingConfirm = useCallback(async (paxCount) => {
    let isResult = false;
    const strAlert = 'Please Let me confirm your reservation.<br><br>You have a [' +
      state.puDateTime.toLocaleTimeString() + '] pick-up on [' +
      formatDate(state.puDateTime, 'MM/dd/yyyy') + ']<br>\tFrom the [' +
      (state.pickupLocation.length <= 0 ? '' : state.pickupLocation) +
      '] <br>for a total of [' + paxCount + '] passanger(s) <br>\tgoing to [' +
      state.dropoffLocation + ']<br>\r\nSPECIAL INSTRUCTION: ' +
      state.specialInstruction + '<br>Is this Correct?';

    await Swal.fire({
      title: '<small>Are you sure</small>', html: strAlert, width: '850px',
      icon: 'question', showCancelButton: true,
      confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Yes', allowOutsideClick: false,
    }).then((result) => { if (result.isConfirmed) isResult = true; });
    return isResult;
  }, [state]);

  const bookReservation = useCallback(async () => {
    const sessionAccountId = parseInt(sessionStorage.getItem('session_accountId') || '0', 10);
    const sessionMappedAccountId3 = parseInt(sessionStorage.getItem('session_mappedAccountId3') || '0', 10);
    const currentTime = sessionStorage.getItem('session_locationTime') === ''
      ? new Date()
      : new Date(sessionStorage.getItem('session_locationTime'));

    let paxCount = (parseInt(state.pilotCount | 0) + parseInt(state.crewCount | 0) + parseInt(state.flightAttandCount | 0));
    let pickupDate = [];

    if (state.tripTypeId === '3') {
      pickupDate = getRecurringPuDateArrayList(state);
    } else if (state.tripTypeId === '2') {
      const stpuDate = moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
      pickupDate = [stpuDate];
    } else {
      for (let tripNo = 0; tripNo < parseInt(state.noOfTrip); tripNo++) {
        const stpuDate = moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
        pickupDate = [stpuDate];
      }
    }

    if (pickupDate.length <= 0) {
      await Swal.fire({ title: '<small>Date Range</small>', text: 'Selected days are not between pick-up date and end date!', icon: 'info', width: '25%', dangerMode: false, allowOutsideClick: false });
      props.submitFunction(false);
      return;
    }

    let fromAreaId = 0, toAreaId = 0, pickupLocationType = '', dropoffLocationType = '';
    const puZone = state.dropdownZone.find((opt) => opt.id === state.pickupZoneId);
    const doZone = state.dropdownZone.find((opt) => opt.id === state.dropoffZoneId);

    if (puZone && doZone) {
      if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
        fromAreaId = puZone.airportId; toAreaId = doZone.id; pickupLocationType = 'AIRPORT'; dropoffLocationType = 'HOTEL';
      } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
        fromAreaId = puZone.id; toAreaId = doZone.airportId; pickupLocationType = 'HOTEL'; dropoffLocationType = 'AIRPORT';
      } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
        fromAreaId = puZone.airportId; toAreaId = doZone.airportId; pickupLocationType = 'AIRPORT'; dropoffLocationType = 'AIRPORT';
      } else {
        fromAreaId = puZone.id; toAreaId = doZone.id; pickupLocationType = 'HOTEL'; dropoffLocationType = 'HOTEL';
      }
    }

    const airlines = state.dropdownAirline.find((opt) => opt.airLineId === state.airlineId);

    const newObject = {};
    newObject.reservationId = state.rideId <= 0 ? 0 : props.tripDetails.reservationId;
    newObject.rideId = state.rideId;
    newObject.affBookingNo = state.affBookingNo === '' ? '' : state.affBookingNo;
    newObject.rideTypeId = rideTypeIdRef.current;
    newObject.fromAreaId = fromAreaId;
    newObject.toAreaId = toAreaId;
    newObject.paxCount = paxCount;
    newObject.paxCountReturn = 0;
    newObject.baggage = 0;
    newObject.firstName = state.paxFirstName === '' ? (airlines ? airlines.code + ' ' + state.flightNumber : state.flightNumber) : state.paxFirstName;
    newObject.lastName = state.paxLastName === '' ? paxCount + ' P' : state.paxLastName;
    newObject.firstNameReturn = '';
    newObject.lastNameReturn = '';

    if (parseInt(state.tripTypeId) === 2) {
      const airlinesReturn = state.dropdownAirline.find((opt) => opt.airLineId === state.airlineIdReturn);
      const paxCountReturn = (parseInt(state.pilotCountReturn | 0) + parseInt(state.crewCountReturn | 0) + parseInt(state.flightAttandCountReturn | 0));
      newObject.firstNameReturn = state.paxFirstName === '' ? (airlinesReturn ? airlinesReturn.code + ' ' + state.flightNumberReturn : state.flightNumberReturn) : state.paxFirstName;
      newObject.lastNameReturn = state.paxLastName === '' ? paxCountReturn + ' P' : state.paxLastName;
      newObject.paxCountReturn = paxCountReturn;
    }

    newObject.countryCode = state.countryCodePhone;
    newObject.phoneNo = state.phoneNumber;
    newObject.cellCountryCode = state.countryCode;
    newObject.mobileNo = state.mobileNumber;
    newObject.customerId = parseInt(state.customer.id);
    newObject.airlineId = parseInt(state.airlineId);
    newObject.flightNumber = state.flightNumber;
    newObject.flightTime = moment(new Date(state.flightTime)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.terminalType = state.terminalType !== '' ? parseInt(state.terminalType) : 0;
    newObject.terminal = state.terminal;
    newObject.airlineIdReturn = state.airlineIdReturn;
    newObject.flightNumberReturn = state.flightNumberReturn;
    newObject.flightTimeReturn = moment(new Date(state.flightTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.terminalTypeReturn = state.terminalTypeReturn !== '' ? parseInt(state.terminalTypeReturn) : 0;
    newObject.terminalReturn = state.terminalReturn;
    newObject.email = state.email;
    newObject.poNumber = state.poNumber;
    newObject.isPickupGoogleBooking = state.isPickupGoogleBooking;
    newObject.pickupLocation = state.pickupLocation;
    newObject.pickupLocationType = pickupLocationType;
    newObject.pickupAddress = state.pickupAddress;
    newObject.pickupCity = state.pickupCity;
    newObject.pickupState = state.pickupState;
    newObject.pickupZipCode = state.pickupZipCode;
    newObject.pickupLatitude = state.pickupLatitude;
    newObject.pickupLongitude = state.pickupLongitude;
    newObject.pickupGeoZoneId = puZone != null ? parseInt(puZone.id) : 0;
    newObject.pickupIsHotel = puZone != null ? puZone.zoneTypeId === 3 : false;
    newObject.isDropoffGoogleBooking = state.isDropoffGoogleBooking;
    newObject.dropoffLocation = state.dropoffLocation;
    newObject.dropoffLocationType = dropoffLocationType;
    newObject.dropoffAddress = state.dropoffAddress;
    newObject.dropoffCity = state.dropoffCity;
    newObject.dropoffState = state.dropoffState;
    newObject.dropoffZipCode = state.dropoffZipCode;
    newObject.dropoffLatitude = state.dropoffLatitude;
    newObject.dropoffLongitude = state.dropoffLongitude;
    newObject.dropoffGeoZoneId = doZone != null ? parseInt(doZone.id) : 0;
    newObject.dropoffIsHotel = doZone != null ? doZone.zoneTypeId === 3 : false;
    newObject.apt = '';
    newObject.orderByName = '';
    newObject.orderByCountryCode = '';
    newObject.orderByPhone = '';
    newObject.orderByEmail = '';
    newObject.approxDropoffTime = moment(new Date(currentTime)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.approxTripDurationMin = 0;
    newObject.reservationModeId = 2;
    newObject.vehicleId = parseInt(vehicleDriverRef.current ? vehicleDriverRef.current.state.filterVehicleId : 0);
    newObject.driverId = parseInt(vehicleDriverRef.current ? vehicleDriverRef.current.state.filterDriverId : 0);
    newObject.serviceSourceId = parseInt(state.serviceSourceId);
    newObject.serviceSourceName = parseInt(state.serviceSourceId) === 1 ? 'In House' : (parseInt(state.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    newObject.otherAffiliateId = parseInt(state.otherAffiliateId);
    newObject.isVipTrip = state.isVipTrip;
    newObject.isMeetGreet = state.isMeetGreet;
    newObject.isAccessible = false;
    newObject.isPriority = false;
    newObject.pickupDateArray = pickupDate;
    newObject.pickupTime = formatTime(state.puDateTime, 'hh:mm:ss');
    newObject.pickupTimeReturn = moment(new Date(state.puDateTimeReturn)).format(DateFormat.DefaultTimeFormat);
    newObject.pickupDateReturn = moment(new Date(state.puDateTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.apiVehicleTypeId = parseInt(state.vehicleTypeId);
    newObject.tripTypeId = parseInt(state.tripTypeId);
    newObject.specialInstruction = state.specialInstruction;
    newObject.permanentRemark = state.permanentRemark;
    newObject.pickupNotes = state.pickupNotes;
    newObject.billToNotes = state.billToNotes;
    newObject.pilotCount = state.pilotCount;
    newObject.crewCount = state.crewCount;
    newObject.flightAttandCount = state.flightAttandCount;
    newObject.pilotCountReturn = state.pilotCountReturn;
    newObject.crewCountReturn = state.crewCountReturn;
    newObject.flightAttandCountReturn = state.flightAttandCountReturn;
    newObject.rateId = state.customerRateTax ? state.customerRateTax.rateId : 0;
    newObject.paymentTypeId = 1;
    newObject.voucherNo = '';
    newObject.voucherCompany = 0;
    newObject.chqBankName = '';
    newObject.chqNumber = '';
    newObject.chqDate = '';
    newObject.creditCardNumber = '';
    newObject.creditCardExpiry = '';
    newObject.cardType = '';
    newObject.transferTypeId = state.customerRateTax ? state.customerRateTax.transferTypeId : 0;
    newObject.serviceTypeId = state.customerRateTax ? state.customerRateTax.serviceTypeId : 0;
    newObject.rideAmount = parseFloat(state.customerRateTax ? state.customerRateTax.rate : 0);
    newObject.tollAmnt = parseFloat(state.customerRateTax ? state.customerRateTax.tollAmount : 0);
    newObject.tipAmnt = parseFloat(state.customerRateTax ? state.customerRateTax.tipAmount : 0);
    newObject.meetGreetCharge = parseFloat(state.customerRateTax ? state.customerRateTax.meetGreetCharge : 0);
    newObject.payToTourGuide = 0.00;
    newObject.tourGuideName = '';
    newObject.tourGuideCharge = 0.00;
    newObject.mgPayTo = 2;
    newObject.meetGreetId = 0;
    newObject.meetGreetName = '';
    newObject.meetGreetAmount = 0.00;
    newObject.mgDriverComms = false;
    newObject.gratuity = '';
    newObject.stop = parseFloat(state.customerRateTax ? state.customerRateTax.stop : 0);
    newObject.noOfStop = 0;
    newObject.wtTotal = 0.00;
    newObject.wtTime = 0;
    newObject.wt = parseFloat(state.customerRateTax ? state.customerRateTax.waitCharge : 0);
    newObject.ot = 0.00;
    newObject.serviceFee = parseFloat(state.customerRateTax ? state.customerRateTax.serviceFee : 0);
    newObject.fuelSurCharge = parseFloat(state.customerRateTax ? state.customerRateTax.fuelSurCharge : 0);
    newObject.parking = parseFloat(state.customerRateTax ? state.customerRateTax.parking : 0);
    newObject.portAuthority = parseFloat(state.customerRateTax ? state.customerRateTax.portAuthority : 0);
    newObject.utilityTax = parseFloat(state.customerRateTax ? state.customerRateTax.utilityTax : 0);
    newObject.wcTax = parseFloat(state.customerRateTax ? state.customerRateTax.wcTax : 0);
    newObject.salesTax = parseFloat(state.customerRateTax ? state.customerRateTax.salesTax : 0);
    newObject.countyTax = parseFloat(state.customerRateTax ? state.customerRateTax.countyTax : 0);
    newObject.congestionTax = parseFloat(state.customerRateTax ? state.customerRateTax.congestionTax : 0);
    newObject.extraAmnt = 0.00;
    newObject.extraAmntFor = '';
    newObject.gross = parseFloat(state.customerRateTax ? state.customerRateTax.fare : 0);
    newObject.discount = parseFloat(state.customerRateTax ? state.customerRateTax.discountCharge : 0);

    if (sessionAccountId === sessionMappedAccountId3) {
      newObject.totalFare = state.rideId <= 0 ? parseFloat(state.customerRateTax ? state.customerRateTax.totalFare : 0) : parseFloat(state.totalFare);
      newObject.driverFees = state.rideId <= 0 ? 0 : parseFloat(state.driverFees);
    } else {
      newObject.totalFare = parseFloat(state.customerRateTax ? state.customerRateTax.totalFare : 0);
    }

    newObject.billableFare = parseFloat(state.customerRateTax ? state.customerRateTax.totalFare : 0);
    newObject.totalPaid = 0.00;
    newObject.chargeTo = '';
    newObject.agentName = state.customerRateTax ? state.customerRateTax.agentName : '';
    newObject.agentId = state.customerRateTax ? state.customerRateTax.agentId : 0;
    newObject.agentCommission = parseFloat(state.customerRateTax ? state.customerRateTax.agentCommission : 0);
    newObject.partialPay = false;
    newObject.rateLocked = false;
    newObject.currencyId = 0;
    newObject.exchangeRate = 0;
    newObject.totalTax = state.customerRateTax
      ? parseFloat(state.customerRateTax.portAuthority) + parseFloat(state.customerRateTax.utilityTax) +
        parseFloat(state.customerRateTax.wcTax) + parseFloat(state.customerRateTax.salesTax) +
        parseFloat(state.customerRateTax.countyTax) + parseFloat(state.customerRateTax.congestionTax)
      : 0;
    newObject.GratuityAmount = 0;
    newObject.tripChangesLogs = state.rideId <= 0 ? '' : getTripChangesDetails(state, props, rideTypeIdRef);

    try {
      props.submitFunction(true);
      const requestParams = getRequestParams('POST', newObject);
      const response = await fetch('reservation-api/book', requestParams);
      const data = await response.json();

      let strAlert = '';
      if (!data.isSuccess) {
        strAlert = data.retValue === -2000 ? data.resultMessage : 'Reservation failed due to server error.';
      } else {
        strAlert = state.rideId <= 0 ? 'Your confirmation number is: <br><br>' : 'Your booking has been modify and updated successfully.<br><br>';
        strAlert += '\t' + data.reservationId + '<br>';
        strAlert += '<br> Thank you.';
      }

      Swal.fire({
        icon: data.isSuccess ? 'success' : 'error',
        title: data.isSuccess ? 'Success' : 'Oops...',
        html: strAlert, width: '750px',
        confirmButtonText: 'Thank you!',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        // Always re-enable the button regardless of outcome
        props.submitFunction(false);
        if (data.isSuccess && result.isConfirmed) {
          if (state.rideId <= 0) {
            if (state.isCopy) {
              if (state.isAttachment) {
                const rideArray = data.tripResult.map((t) => t.tripId);
                props.attachmentUpload(rideArray);
              } else if (state.isSendEmail) {
                props.openEmailModal(state.puDateTime, data.tripResult[0].tripId, state.email);
              } else {
                props.goToBackPage();
              }
            } else {
              if (state.isAttachment) {
                const rideArray = data.tripResult.map((t) => t.tripId);
                props.attachmentUpload(rideArray);
              } else if (state.isSendEmail) {
                props.openEmailModal(state.puDateTime, data.tripResult[0].tripId, state.email);
              }
              clearAllControls(setState, state.customer);
            }
          } else {
            if (state.isAttachment) {
              props.attachmentUpload([state.rideId]);
            } else {
              props.goToBackPage();
            }
          }
        }
      });
    } catch (e) {
      props.submitFunction(false);
      Swal.fire({ title: '<small>Error</small>', text: 'Reservation failed. Please try again.', icon: 'error', width: '25%', allowOutsideClick: false });
    }
  }, [state, setState, rideTypeIdRef, vehicleDriverRef, props]);

  const loadPage = useCallback(async (data) => {
    try {
      setState({ customer: data, airlineId: data.airlineId });

      await Promise.all([
        getAirlines(),
        getVehicleType(),
        getAffiliates(),
        getZones(),
      ]);

      if (props.tripDetails != null) {
        isLoadingTimeRef.current = true;
        const tripDetails = props.tripDetails;
        const rideTypeIdVal = parseInt(tripDetails.rideTypeId);
        rideTypeIdRef.current = rideTypeIdVal;

        let puZone = null;
        let doZone = null;
        setState((prev) => {
          const zones = prev.dropdownZone;
          if (rideTypeIdVal === 1) {
            puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 2) {
            puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 3) {
            puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else {
            puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          }
          return prev;
        });

        const paxCount = (parseInt(tripDetails.iPilot | 0) + parseInt(tripDetails.iCrew | 0) + parseInt(tripDetails.iFlightAttendent | 0)) || 1;
        await getCustomerRateTaxSetting(
          puZone != null ? puZone.id : 0,
          doZone != null ? doZone.id : 0,
          new Date(tripDetails.puDateTime),
          tripDetails.apiVehicleTypeId,
          paxCount, 0,
          tripDetails.isMgRequired,
        );

        const currentTime = sessionStorage.getItem('session_locationTime') === ''
          ? new Date()
          : new Date(sessionStorage.getItem('session_locationTime'));

        setState((prev) => {
          const zones = prev.dropdownZone;
          let pu = null; let dz = null;
          if (rideTypeIdVal === 1) {
            pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 2) {
            pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 3) {
            pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else {
            pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          }
          return {
            ...prev,
            paxFirstName: tripDetails.firstName,
            paxLastName: tripDetails.lastName,
            countryCodePhone: tripDetails.countryCode,
            phoneNumber: tripDetails.phoneNo,
            countryCode: tripDetails.cellCountryCode,
            mobileNumber: tripDetails.mobileNo,
            email: tripDetails.emailId,
            airlineId: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId,
            flightNumber: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo,
            terminalType: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId,
            terminal: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal,
            pilotCount: tripDetails.iPilot,
            crewCount: tripDetails.iCrew,
            flightAttandCount: tripDetails.iFlightAttendent,
            flightTime: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime) : new Date(tripDetails.doFlightDateTime),
            flightHour: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime).getHours() : new Date(tripDetails.doFlightDateTime).getHours(),
            flightMinute: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime).getMinutes() : new Date(tripDetails.doFlightDateTime).getMinutes(),
            airlineIdReturn: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.DoAirlineId,
            flightNumberReturn: '',
            terminalTypeReturn: 1,
            terminalReturn: '',
            flightTimeReturn: currentTime,
            flightHourReturn: new Date(currentTime).getHours(),
            flightMinuteReturn: new Date(currentTime).getMinutes(),
            pilotCountReturn: 0,
            crewCountReturn: 0,
            flightAttandCountReturn: 0,
            poNumber: tripDetails.crewPo == null ? '' : tripDetails.crewPo,
            isPickupGoogleBooking: false,
            pickupLocation: tripDetails.puLocationName,
            pickupZoneId: pu != null ? pu.id : 0,
            pickupAddress: tripDetails.puAddress,
            pickupAddressType: '',
            pickupCity: tripDetails.puCity,
            pickupState: tripDetails.puStateName,
            pickupZipCode: tripDetails.puZipCode,
            pickupLatitude: tripDetails.puLatitude,
            pickupLongitude: tripDetails.puLongitude,
            isDropoffGoogleBooking: false,
            dropoffLocation: tripDetails.doLocationName,
            dropoffZoneId: dz != null ? dz.id : 0,
            dropoffAddress: tripDetails.doAddress,
            dropoffAddressType: '',
            dropoffCity: tripDetails.doCity,
            dropoffState: tripDetails.doStateName,
            dropoffZipCode: tripDetails.doZipCode,
            dropoffLatitude: tripDetails.doLatitude,
            dropoffLongitude: tripDetails.doLongitude,
            serviceSourceId: tripDetails.serviceSourceId != null ? tripDetails.serviceSourceId : 1,
            otherAffiliateId: tripDetails.serviceSourceAffiliateId,
            isVipTrip: tripDetails.vip === 'Y',
            isMeetGreet: tripDetails.isMgRequired,
            puDateTime: new Date(tripDetails.puDateTime),
            puDateTimeReturn: currentTime,
            vehicleTypeId: parseInt(tripDetails.apiVehicleTypeId),
            noOfTrip: 1,
            tripTypeId: '1',
            recurringTypeId: 2,
            recurringEndDate: '',
            selectedDays: [],
            isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
            isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
            specialInstruction: tripDetails.specialInstruction,
            permanentRemark: tripDetails.permanentRemark,
            pickupNotes: tripDetails.pickUpNotes,
            billToNotes: tripDetails.billToNotes,
          };
        });

        if (vehicleDriverRef.current) {
          vehicleDriverRef.current.state.filterVehicleId = tripDetails.vehicleId;
          vehicleDriverRef.current.state.filterDriverId = tripDetails.driverId;
        }
        isLoadingTimeRef.current = false;
      }
    } catch (ex) {
      console.log(ex);
    }
  }, [getAirlines, getVehicleType, getAffiliates, getZones, getCustomerRateTaxSetting, setState, rideTypeIdRef, isLoadingTimeRef, vehicleDriverRef, props]);

  const copyReservation = useCallback(async () => {
    try {
      if (props.tripDetails == null) return;

      isLoadingTimeRef.current = true;
      setState({ loadPanelVisible: true });

      const tripDetails = props.tripDetails;
      const rideTypeIdVal = parseInt(tripDetails.rideTypeId);
      rideTypeIdRef.current = rideTypeIdVal;

      let puZone = null;
      let doZone = null;
      setState((prev) => {
        const zones = prev.dropdownZone;
        if (rideTypeIdVal === 1) {
          puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 2) {
          puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 3) {
          puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else {
          puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        }
        return prev;
      });

      const currentTime = sessionStorage.getItem('session_locationTime') === ''
        ? new Date()
        : new Date(sessionStorage.getItem('session_locationTime'));
      const currentHour = new Date(currentTime).getHours();
      const currentMinute = new Date(currentTime).getMinutes();

      const paxCount = (parseInt(tripDetails.iPilot | 0) + parseInt(tripDetails.iCrew | 0) + parseInt(tripDetails.iFlightAttendent | 0)) || 1;
      await getCustomerRateTaxSetting(
        puZone != null ? puZone.id : 0,
        doZone != null ? doZone.id : 0,
        currentTime,
        tripDetails.apiVehicleTypeId,
        paxCount, 0,
        tripDetails.isMgRequired,
      );

      setState((prev) => {
        const zones = prev.dropdownZone;
        let pu = null; let dz = null;
        if (rideTypeIdVal === 1) {
          pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 2) {
          pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 3) {
          pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else {
          pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        }
        return {
          ...prev,
          isCopy: true,
          rideId: 0,
          paxFirstName: tripDetails.firstName,
          paxLastName: tripDetails.lastName,
          countryCodePhone: tripDetails.countryCode,
          phoneNumber: tripDetails.phoneNo,
          countryCode: tripDetails.cellCountryCode,
          mobileNumber: tripDetails.mobileNo,
          email: tripDetails.emailId,
          airlineId: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId,
          flightNumber: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo,
          terminalType: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId,
          terminal: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal,
          pilotCount: tripDetails.iPilot,
          crewCount: tripDetails.iCrew,
          flightAttandCount: tripDetails.iFlightAttendent,
          flightTime: currentTime,
          flightHour: currentHour,
          flightMinute: currentMinute,
          airlineIdReturn: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.DoAirlineId,
          flightNumberReturn: '',
          terminalTypeReturn: 1,
          terminalReturn: '',
          flightTimeReturn: currentTime,
          flightHourReturn: currentHour,
          flightMinuteReturn: currentMinute,
          pilotCountReturn: 0,
          crewCountReturn: 0,
          flightAttandCountReturn: 0,
          poNumber: (tripDetails.crewPo == null) ? '' : tripDetails.crewPo,
          isPickupGoogleBooking: false,
          pickupLocation: tripDetails.puLocationName,
          pickupZoneId: pu != null ? pu.id : 0,
          pickupAddress: tripDetails.puAddress,
          pickupAddressType: '',
          pickupCity: tripDetails.puCity,
          pickupState: tripDetails.puStateName,
          pickupZipCode: tripDetails.puZipCode,
          pickupLatitude: tripDetails.puLatitude,
          pickupLongitude: tripDetails.puLongitude,
          isDropoffGoogleBooking: false,
          dropoffLocation: tripDetails.doLocationName,
          dropoffZoneId: dz != null ? dz.id : 0,
          dropoffAddress: tripDetails.doAddress,
          dropoffAddressType: '',
          dropoffCity: tripDetails.doCity,
          dropoffState: tripDetails.doStateName,
          dropoffZipCode: tripDetails.doZipCode,
          dropoffLatitude: tripDetails.doLatitude,
          dropoffLongitude: tripDetails.doLongitude,
          serviceSourceId: tripDetails.serviceSourceId != null ? tripDetails.serviceSourceId : 1,
          otherAffiliateId: tripDetails.serviceSourceAffiliateId,
          isVipTrip: tripDetails.vip === 'Y',
          isMeetGreet: tripDetails.isMgRequired,
          puDateTime: currentTime,
          puDateTimeReturn: currentTime,
          vehicleTypeId: parseInt(tripDetails.apiVehicleTypeId),
          noOfTrip: 1,
          tripTypeId: '1',
          recurringTypeId: 2,
          recurringEndDate: '',
          selectedDays: [],
          isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
          isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
          specialInstruction: tripDetails.specialInstruction,
          permanentRemark: tripDetails.permanentRemark,
          pickupNotes: tripDetails.pickUpNotes,
          billToNotes: tripDetails.billToNotes,
          customerRateTax: null,
        };
      });

      if (vehicleDriverRef.current) {
        vehicleDriverRef.current.state.filterVehicleId = 0;
        vehicleDriverRef.current.state.filterDriverId = 0;
      }

      setState({ loadPanelVisible: false });

      await Swal.fire({
        title: '<small>Copy Reservation</small>', text: 'Reservation copied successfully.',
        icon: 'success', width: '25%', dangerMode: false, allowOutsideClick: false,
      });

      isLoadingTimeRef.current = false;
    } catch (ex) {
      console.log(ex);
    }
  }, [getCustomerRateTaxSetting, vehicleDriverRef, rideTypeIdRef, isLoadingTimeRef, setState, props]);

  return {
    loadPage,
    copyReservation,
    getAirlines,
    getVehicleType,
    getAffiliates,
    getZones,
    getRideTypeId,
    getCustomerRateTaxSetting,
    getBookingSuggestions,
    checkDuplicateReservation,
    bookReservation,
    askDuplicateConfirm,
    askScheduleTimeConfirm,
    askReturnTripConfirm,
    askBookingConfirm,
  };
}
